import UIUtils from './ui-utils.js'; 

class Selectable {
   
    constructor(gridElement, itemSelector) {
        if (!gridElement) {
            console.warn("Selectable: Grid element is not provided.");
            return;
        }

        this.grid = gridElement;
        this.items = this.grid.querySelectorAll(itemSelector);
        if (this.items.length === 0) {
            console.warn("Selectable: No items found in the grid.");
            return;
        }

        this.lastClickedIndex = null;
        this.openInNewTab = this.grid.dataset.openInNewTab === "true";
        this.addEventListeners();
    }

    addEventListeners() {
        this.items.forEach((item, index) => {
            item.addEventListener('click', (event) => this.handleItemClick(event, index));
            item.addEventListener('dblclick', (event) => this.handleItemDoubleClick(event, index));
        });

        document.addEventListener('keydown', (event) => {
            if (event.ctrlKey && event.key === 'a') {
                event.preventDefault();
                this.toggleSelectAllItems();
            }
        });
    }

    handleItemClick(event, index) {

        if (event.target.closest('.folder')) {
            // Do not toggle the selected class, just follow the hyperlink
            return;
        }

        if (event.shiftKey && this.lastClickedIndex !== null) {
            const start = Math.min(index, this.lastClickedIndex);
            const end = Math.max(index, this.lastClickedIndex);
            const isSelecting = !event.currentTarget.classList.contains('selected');

            for (let i = start; i <= end; i++) {
                this.items[i].classList.toggle('selected', isSelecting);
            }
        } else {
            event.currentTarget.classList.toggle('selected');
            this.lastClickedIndex = index;
        }
        this.dispatchSelectionEvent();
    }

    handleItemDoubleClick(event, index) {
        if (this.openInNewTab) {
            this.openItemInNewTab(event.currentTarget);
        } else {
            this.openItemDetails(event.currentTarget);
        }
    }

    toggleSelectAllItems() {
        const areAllSelected = this.items.length === this.getSelectedCount();
        this.items.forEach(item => item.classList.toggle('selected', !areAllSelected));
        this.dispatchSelectionEvent();
    }

    dispatchSelectionEvent() {
        const selectedItems = this.grid.querySelectorAll('.item.selected');

        const selectionEvent = new CustomEvent('selectionChanged', {
            detail: {
                selectedItems: Array.from(selectedItems),
                count: selectedItems.length
            }
        });

        this.grid.dispatchEvent(selectionEvent);
    }

    getSelectedItems() {
        return this.grid.querySelectorAll('.item.selected');
    }

    getSelectedCount() {
        return this.getSelectedItems().length;
    }

    openItemDetails(itemElement) {
        const itemId = itemElement.dataset.id;
        const contributorId = document.querySelector('.breadcrumb [data-contributor-id]')?.dataset.contributorId;
        const hostId = document.querySelector('.breadcrumb [data-host-id]')?.dataset.hostId;
        const modalUrl = `/details/${contributorId}/${hostId}/${itemId}`;

        UIUtils.openModal(modalUrl,
            null,
            () => { /* onOpen callback */ },
            () => { /* onClose callback */ },
            () => true // beforeClose callback
        );
    }

    openItemInNewTab(itemElement) {
        const url = itemElement.dataset.url;
        window.open(url, '_blank');
    }
}

export default Selectable;